import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
}
`;

export const PhoneNumberArea = styled.div`
    right: 20px;
    position: absolute;
}
`;
